import React from 'react';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { Checkbox } from 'primereact/checkbox';

export const UpperControls = ({ 
  search, 
  setSearch, 
  showFilters, 
  setShowFilters, 
  selectedFilters,
  setSelectedFilters,
  handleFilterToggle,
  handleSelectAllFilters,
  uniqueProductNames,
  onShowModifications,
  bulkLoading,
  hasModifications
}) => {
  return (
    <div className="other-table__upper">
      <div className="other-table__upper__controls">
        <span className="p-inputgroup">
          <span className="p-inputgroup-addon">
            <i className="pi pi-search"></i>
          </span>
          <InputText 
            placeholder="Search..." 
            className="other-table__upper__controls__filter-button" 
            onChange={(e) => setSearch(e.target.value)} 
            value={search}
          />
        </span>
        
        <div className="other-table__filter-container">
          <Button 
            onClick={() => setShowFilters(!showFilters)} 
            icon="pi pi-filter" 
            label={''} 
            className={`other-table__upper__controls__filter-button ${showFilters ? 'p-button-highlighted' : ''} ${selectedFilters.length > 0 ? 'filters-active' : ''}`} 
          />
          {showFilters && (
            <div className="other-table__filters-popup">
              <div className="other-table__filters-popup__item">
                <Checkbox 
                  checked={selectedFilters.length === uniqueProductNames.length}
                  onChange={(e) => handleSelectAllFilters(e.checked)}
                  id="filter-select-all"
                />
                <label htmlFor="filter-select-all">Select All</label>
              </div>
              {uniqueProductNames.map(name => (
                <div key={name} className="other-table__filters-popup__item">
                  <Checkbox 
                    checked={selectedFilters.includes(name)}
                    onChange={() => handleFilterToggle(name)}
                    id={`filter-${name}`}
                  />
                  <label htmlFor={`filter-${name}`}>{name}</label>
                </div>
              ))}
            </div>
          )}
        </div>
        <div className="other-table__filter-container">
        <Button 
            onClick={onShowModifications} 
            icon={bulkLoading ? "pi pi-spinner pi-spin" : "pi pi-save"} 
            iconPos='left' 
            disabled={!hasModifications() || bulkLoading} 
            label={''} 
            className="other-table__upper__controls__save-button" 
        />
        </div>
      </div>
    </div>
  );
}; 